import { Button } from "@/components/ui/button"
import { Sparkles } from "lucide-react"
import { cn } from "@/lib/utils"

interface AIGenerateButtonProps {
  isGenerating: boolean
  onClick: () => void
}

export function AIGenerateButton({ isGenerating, onClick }: AIGenerateButtonProps) {
  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={isGenerating}
      className={cn(
        "bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700",
        "text-white shadow-lg hover:shadow-xl transition-all duration-200",
        "relative",
        isGenerating && "animate-pulse"
      )}
    >
      {isGenerating ? (
        <>
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 animate-pulse rounded-md" />
          <Sparkles className="w-4 h-4 mr-2 animate-spin" />
          Generating...
        </>
      ) : (
        <>
          <Sparkles className="w-4 h-4 mr-2" />
          Polish
        </>
      )}
    </Button>
  )
}